import { Form, InputNumber } from "antd";
import { formatter, parser } from "../../utils/utilities/InputSumFunctions";
import { validateDate } from "../../utils/utilities/ValidateDate";
import {
  ruleRequired,
  ruleSummMinMax,
} from "../../constants/rules/RulesConstantsForms";
import { UI_ITODatePicker } from "../UI_ITODatePicker/UI_ITODatePicker";
import dayjs from "dayjs";
import { datePickerGetValuePropsFormItem } from "../../utils/utilities/DatePickerGetValuePropsFormItem";
import { IUiModuleInfoProps } from "../../interfaces/Ui/IUi_ModuleInfo/IUiModuleInfoProps";
import { ChildrenWrapper } from "../../utils/HOC/ChildrenWrapper";

import classes from "./UI_ITOModuleInfo.module.css";
import { nanoid } from "nanoid";

/**
 * Компонент выводит карточку с информацией (итогами) по конкретному запросу.
 *
 * @param {IUiModuleInfoProps} props - Параметры компонента
 * @param {string} [props.className] - Классы для wrapper-элемента (по умолчанию пустая строка)
 * @param {string} props.title - Заголовок карточки
 * @param {Array<{name: string, value: string}>} props.data - Массив с информацией (итогами) по конкретному запросу
 */
export function UI_ModuleInfo(props: IUiModuleInfoProps): JSX.Element {
  const { className = "", title, data } = props;

  return (
    <div className={`${className} ${classes.card}`}>
      {data?.map((item) => {
        const uniqueKey = nanoid();

        if (item?.title) {
          return (
            <div className={classes.title} key={uniqueKey}>
              {item.title}
            </div>
          );
        }
        if (item?.type) {
          const { type, name, value, href, typeTitle } = item;
          return (
            <div key={uniqueKey} className={classes.data}>
              <div
                className={`${classes.key} ${
                  typeTitle ? classes[typeTitle] : ""
                }`}
              >
                {name}
              </div>
              <div className={classes.value} style={{ color: type.color }}>
                <ChildrenWrapper type={type} href={href}>
                  {value}
                </ChildrenWrapper>
              </div>
            </div>
          );
        } else if (title === "Начало и окончание БГ") {
          return (
            <Form.Item
              key={uniqueKey}
              label={item.label}
              name={item.name}
              rules={[
                ruleRequired,
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const fieldValue = getFieldValue(item.name);
                    const inputValue = new Date(value);

                    return validateDate({ fieldValue, inputValue });
                  },
                }),
              ]}
              getValueProps={datePickerGetValuePropsFormItem}
              className={`${classes.infoInput} ${
                item.typeTitle ? classes[item.typeTitle] : ""
              }`}
            >
              <UI_ITODatePicker
                minDate={dayjs(new Date())}
                style={{ border: "none" }}
              />
            </Form.Item>
          );
        } else {
          return (
            <Form.Item
              key={uniqueKey}
              label={item.label}
              name={item.name}
              rules={[ruleRequired, ruleSummMinMax]}
              className={`${classes.infoInput} ${
                item.typeTitle ? classes[item.typeTitle] : ""
              }`}
            >
              <InputNumber
                controls={false}
                style={{ width: "100%", border: "none" }}
                formatter={formatter}
                parser={parser}
              />
            </Form.Item>
          );
        }
      })}
    </div>
  );
}
